"use client";
import React from "react";

/**
 * A react hook that provides functionality to control the styles provided
 * for the outline of a focused element.
 * @param onBlur the callback function fired when a user moves off of an element (optional)
 */
export const useFocusControls = (
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void
) => {
  const [isOutlineVisible, setIsOutlineVisible] = React.useState(false);

  const ignoreFocusRef = React.useRef(false);

  const preventOutlineOnClick = React.useCallback(() => {
    ignoreFocusRef.current = true;
  }, []);

  const handleFocus = React.useCallback(() => {
    if (!ignoreFocusRef.current) {
      setIsOutlineVisible(true);
    }
    ignoreFocusRef.current = false;
  }, []);

  const handleBlur = React.useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      setIsOutlineVisible(false);
      if (onBlur) {
        onBlur(event);
      }
    },
    [onBlur]
  );

  return [
    isOutlineVisible,
    preventOutlineOnClick,
    handleFocus,
    handleBlur
  ] as const;
};
